import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BaseSiteService } from '@spartacus/core';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-receiving-hours',
  templateUrl: './receiving-hours.component.html',
  styleUrls: ['./receiving-hours.component.scss'],
})
export class ReceivingHoursComponent implements OnInit, OnDestroy {
  @Input() deliveryTimings;
  @Input() fromModule;
  @Input() fullWidth;
  @Input() disableEdit = false; //default Value -flag to disable edit link on true
  @Output() update: EventEmitter<any> = new EventEmitter();
  @Output() EditVal: EventEmitter<any> = new EventEmitter();
  baseSiteId: any;
  activeSeasonId;
  showTimings: boolean = true;
  constructor(
    private readonly fb: FormBuilder,
    private readonly baseSiteService: BaseSiteService,
    private readonly sharedService: SharedService,
    private readonly cdr: ChangeDetectorRef,
    private readonly pfService: CustomProfileAndPreferencesService
  ) {}
  timings = [
    'Closed',
    '24 hours',
    '4:00 am',
    '4:30 am',
    '5:00 am',
    '5:30 am',
    '6:00 am',
    '6:30 am',
    '7:00 am',
    '7:30 am',
    '8:00 am',
    '8:30 am',
    '9:00 am',
    '9:30 am',
    '10:00 am',
    '10:30 am',
    '11:00 am',
    '11:30 am',
    '12:00 pm',
    '12:30 pm',
    '1:00 pm',
    '1:30 pm',
    '2:00 pm',
    '2:30 pm',
    '3:00 pm',
    '3:30 pm',
    '4:00 pm',
    '4:30 pm',
    '5:00 pm',
    '5:30 pm',
    '6:00 pm',
    '6:30 pm',
    '7:00 pm',
    '7:30 pm',
    '8:00 pm',
    '8:30 pm',
  ];
  deliveryHours: Array<any>;
  deliveryHoursCopy: Array<any>;
  editMode = false;
  showErrorFor: any = null;
  timingForm: FormGroup;

  showFromTimeList = false;
  showToTimeList = false;
  showFromTimeListFor: number = null;
  showToTimeListFor: number = null;
  noTimingsSelected = [
    {
      day: 'MONDAY',
      fromTime: '',
      toTime: '',
    },
    {
      day: 'TUESDAY',
      fromTime: '',
      toTime: '',
    },
    {
      day: 'WEDNESDAY',
      fromTime: '',
      toTime: '',
    },
    {
      day: 'THURSDAY',
      fromTime: '',
      toTime: '',
    },
    {
      day: 'FRIDAY',
      fromTime: '',
      toTime: '',
    },
  ];
  hideBtns = false;
  pfserviceSub: Subscription;
  baseSub: Subscription;

  ngOnChanges(change: SimpleChanges): void {
    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    if (change.deliveryTimings?.currentValue) {
      this.showTimings = this.deliveryTimings?.length;
      this.deliveryHours = JSON.parse(
        JSON.stringify(
          (this.deliveryTimings?.length && this.deliveryTimings) ||
            this.noTimingsSelected
        )
      );
      this.deliveryHoursCopy = JSON.parse(JSON.stringify(this.deliveryHours));
    }
  }

  ngOnInit(): void {
    const seasonID = this.sharedService.getSessionStorage('activeSeasons');
    this.activeSeasonId = seasonID;
    this.pfserviceSub = this.pfService.invokeActionsInRecevingHoursComp
      .pipe(filter((res) => !!res))
      .subscribe((res) => {
        switch (res) {
          case 'edit':
            this.hideBtns = true;
            this.editAction('edit');
            break;
          case 'update':
            this.updateTimings();
            break;
          default:
            this.hideBtns = true;
            this.editAction('close');
        }
      });
  }
  ngOnDestroy(): void {
    this.pfserviceSub?.unsubscribe();
    this.baseSub?.unsubscribe();
  }
  editAction(txt) {
    this.editMode = !this.editMode;
    this.showErrorFor = null;
    if (txt == 'close') {
      this.deliveryHours = JSON.parse(JSON.stringify(this.deliveryHoursCopy));
      this.showRequiredErrorFor = [];
      this.showFromTimeList = false;
      this.showFromTimeListFor = null;
      this.showToTimeList = false;
      this.showToTimeListFor = null;
    }
    this.EditVal.emit(this.editMode);
    this.cdr.detectChanges();
  }

  selectedTime(chosenTime, forDay, time, index) {
    let selectedTime = chosenTime.trim();
    this.deliveryHours.forEach((item) => {
      if (item.day === forDay) {
        if (time == 'toTime') {
          if (this.findTimeDiff(item['fromTime'], selectedTime) <= 0) {
            this.showErrorFor = index;
            setTimeout(() => {
              this.showErrorFor = null;
            }, 5000);
          } else if (!['24 hours', 'Closed'].includes(selectedTime)) {
            item[time] = selectedTime;
          }
          this.showToTimeList = false;
          this.showToTimeListFor = null;
          if (
            this.showRequiredErrorFor.includes(index) &&
            !['24 hours', 'Closed'].includes(selectedTime)
          ) {
            this.showRequiredErrorFor.splice(
              this.showRequiredErrorFor.indexOf(index),
              1
            );
          }
        } else if (time == 'fromTime') {
          item[`${time}`] = selectedTime;
          ['24 hours', 'Closed'].includes(selectedTime)
            ? (item.toTime = selectedTime)
            : (item.toTime = '');
          if (selectedTime !== 'Closed') this.closedOnAllDays = false;
          this.showFromTimeList = false;
          this.showFromTimeListFor = null;
        }
      }
    });
  }

  findTimeDiff(frmTime: string, toTime: string) {
    const duration = moment.duration(
      moment(toTime, 'HH:mm a').diff(moment(frmTime, 'HH:mm a'))
    );
    return duration.asHours();
  }
  showRequiredErrorFor: Array<number> = [];
  closedOnAllDays = false;
  updateTimings() {
    let a = this.getAllToTimes();
    if (a.includes('')) {
      a.forEach((el, i) => {
        if (el == '' && !this.showRequiredErrorFor.includes(i))
          this.showRequiredErrorFor.push(i);
      });
      this.update.emit('ERROR');
    } else if (
      this.fromModule == 'reserveContact' &&
      a.every((time) => time.toLowerCase() == 'closed')
    ) {
      this.closedOnAllDays = true;
    } else {
      this.deliveryHoursCopy = JSON.parse(JSON.stringify(this.deliveryHours));
      this.update.emit(this.deliveryHours);
      this.editMode = !this.editMode;
      this.showTimings = true;
      this.showRequiredErrorFor = [];
    }
    this.showFromTimeList = false;
    this.showFromTimeListFor = null;
    this.showToTimeList = false;
    this.showToTimeListFor = null;
    this.cdr.detectChanges();
  }

  getAllToTimes(): Array<any> {
    let arr: Array<any> = [];
    this.deliveryHours.filter((obj) => {
      arr.push(obj.toTime);
    });

    return arr;
  }

  changeOption(e, index) {
    const ctrl = document.getElementById('fromTime' + index);
    (document.getElementById('fromTime' + index) as HTMLInputElement).value =
      e.target.textContent;
  }
}
